import React from "react";
import { Link } from "react-router-dom";

export default function EcoProducts() {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 bg-green-50 dark:bg-green-900">
      <div className="container px-4 md:px-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none text-green-900 dark:text-green-100">
            Eco-Friendly Products
          </h1>
          <p className="mx-auto max-w-[700px] mt-4 text-gray-500 md:text-xl dark:text-gray-400">
            Explore our range of eco-friendly products that are good for you and
            the planet.
          </p>
        </div>
        <div className="grid gap-6 md:gap-8 mt-12 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-transform duration-300 ease-in-out hover:-translate-y-2">
            <Link
              to="https://thaely.in/"
              className="absolute inset-0 z-10"
              href="#"
            >
              <span className="sr-only">View</span>
            </Link>
            <img
              alt="Product 1"
              className="object-cover w-full h-64"
              height={400}
              src="data:image/png;base64,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"
              style={{
                aspectRatio: "500/400",
                objectFit: "cover",
              }}
              width={500}
            />
            <div className="bg-white p-4 dark:bg-gray-950">
              <h3 className="font-bold text-xl text-green-900 dark:text-green-100">
                Thaely: Vegan, Recycled Plastic Bags and Sustainable Sneakers.
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                No chemicals used
              </p>
              <div className="flex items-center mt-2">
                <LeafIcon className="h-5 w-5 text-green-500 dark:text-green-300" />
                <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
                  Eco-Friendly
                </span>
              </div>
            </div>
          </div>
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-transform duration-300 ease-in-out hover:-translate-y-2">
            <Link className="absolute inset-0 z-10" href="#">
              <span className="sr-only">View</span>
            </Link>
            <img
              alt="Product 2"
              className="object-cover w-full h-64"
              height={400}
              src="https://www.f6s.com/content-resource/profiles/3468555_th1.jpg"
              style={{
                aspectRatio: "500/400",
                objectFit: "cover",
              }}
              width={500}
            />
            <div className="bg-white p-4 dark:bg-gray-950">
              <h3 className="font-bold text-xl text-green-900 dark:text-green-100">
                Without:Recycled Sunglasses
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Made from plastic cover of chips
              </p>
              <div className="flex items-center mt-2">
                <LeafIcon className="h-5 w-5 text-green-500 dark:text-green-300" />
                <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
                  Eco-Friendly
                </span>
              </div>
            </div>
          </div>
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-transform duration-300 ease-in-out hover:-translate-y-2">
            <Link className="absolute inset-0 z-10" href="#">
              <span className="sr-only">View</span>
            </Link>
            <img
              alt="Product 3"
              className="object-cover w-full h-64"
              height={400}
              src="https://cdn.shopify.com/s/files/1/0149/8336/4708/files/logo.png?height=628&pad_color=f0f8fc&v=1613767441&width=1200"
              style={{
                aspectRatio: "500/400",
                objectFit: "cover",
              }}
              width={500}
            />
            <div className="bg-white p-4 dark:bg-gray-950">
              <h3 className="font-bold text-xl text-green-900 dark:text-green-100">
                Green Toys: Recycled milk jugs into imaginative playthings
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Biodegradable and sustainable
              </p>
              <div className="flex items-center mt-2">
                <LeafIcon className="h-5 w-5 text-green-500 dark:text-green-300" />
                <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
                  Eco-Friendly
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function LeafIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
    </svg>
  );
}
